import {
    GET_REDEMPTIONS,
    SET_REDEMPTIONS,
    SET_REDEMPTIONS_PAGINATION,
    RESET_REDEMPTIONS
} from '../actions/redemptions.js'

const initialState = {
    count: 0,
    rows: [],
    pagination: {
        page: 1,
        perPage: 25,
        start: 1,
        end: 25, 
    },
}

export default (state = initialState, {
    type,
    payload,
}) => {
    let newState = {};
    switch (type) {
        case SET_REDEMPTIONS:
            newState = {
                ...state,
                ...payload,
                pagination: {
                    ...state.pagination,
                },
            };
            newState.pagination.start = newState.pagination.page > 1 ? ((newState.pagination.page - 1) * newState.pagination.perPage) + 1 : 1;
            newState.pagination.end = newState.pagination.start + newState.pagination.perPage - 1;
            newState.pagination.end = newState.pagination.end > newState.count ? newState.count : newState.pagination.end;
            return newState;
        case SET_REDEMPTIONS_PAGINATION:
            newState = {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...payload,
                },
            };
            newState.pagination.start = newState.pagination.page > 1 ? ((newState.pagination.page - 1) * newState.pagination.perPage) + 1 : 1;
            newState.pagination.end = newState.pagination.start + newState.pagination.perPage - 1;
            newState.pagination.end = newState.pagination.end > newState.count ? newState.count : newState.pagination.end;
            return newState;
        case RESET_REDEMPTIONS:
            return initialState;
        case GET_REDEMPTIONS:
        default:
            return state;
    }
}